export const BOOKING_STEP = {
  DATETIME_PICKER: 'datetimePicker',
  AUTHENTICATION: 'authentication',
  SESSION_ERROR: 'sessionError',
  AVAILABILITY_ERROR: 'availabilityError',
}
